import { ref, onMounted, onBeforeUnmount } from "vue";
import { useExplorerStore } from "@/modules/explorer/store";

export function useHotkeys(callback, keysCombination) {
	const acceptedKeys = ["Ctrl", "Shift", "Alt"];

	const keyMapping = {
		Ctrl: "ctrlKey",
		Shift: "shiftKey",
		Alt: "altKey",
	};

	const activeKeys = keysCombination.reduce((acc, curr) => {
		if (acceptedKeys.includes(curr)) {
			acc[curr] = true;
		} else {
			acc.key = curr;
		}
		return acc;
	}, {});

	const handleKeyDown = (event) => {
		if (!useExplorerStore().explorerState.areHotkeysEnabled) {
			return;
		}
		//console.log(event.key); // can be usefull for finding the keys to map :)

		const isMatch = acceptedKeys.every((key) => {
			return Boolean(activeKeys[key]) === event[keyMapping[key]];
		});

		if (isMatch && event.key.toLowerCase() === activeKeys.key?.toLowerCase()) {
			event.preventDefault();
			callback();
		}
	};

	onMounted(() => {
		window.addEventListener("keydown", handleKeyDown);
	});

	onBeforeUnmount(() => {
		window.removeEventListener("keydown", handleKeyDown);
	});
}
